import { useQuery, useQueryClient } from "@tanstack/react-query";
import { boronClient } from "../../../api";
import { createError } from "../../../errors";
import { AiAssistantTemplateInterface } from "../../SectionsSettingsAiAssistantTemplatesPage/useFetchAiAssistantTemplates";

const path =
  "/api/v1/sections/{section_id}/ai_assistant_templates/{id}" as const;

const buildQueryKey = (sectionId: string, templateId: string) => [
  path,
  sectionId,
  templateId,
];

export const useFetchAiAssistantTemplate = ({
  sectionId,
  templateId,
}: {
  sectionId: string;
  templateId: string;
}) => {
  return useQuery<AiAssistantTemplateInterface>({
    queryKey: buildQueryKey(sectionId, templateId),
    queryFn: async () => {
      const { response, data } = await boronClient.GET(path, {
        params: {
          path: {
            section_id: sectionId,
            id: Number(templateId),
          },
        },
      });
      if (response.ok && data) {
        return data.aiAssistantTemplate;
      }
      throw await createError(response);
    },
  });
};

export const useAiAssistantTemplateCacheUpdater = () => {
  const queryClient = useQueryClient();

  const updateAiAssistantTemplate = (
    sectionId: string,
    template: AiAssistantTemplateInterface,
  ) => {
    queryClient.setQueryData(
      buildQueryKey(sectionId, String(template.id)),
      template,
    );
  };

  const removeAiAssistantTemplate = (sectionId: string, templateId: string) => {
    queryClient.removeQueries({
      queryKey: buildQueryKey(sectionId, templateId),
    });
  };

  return {
    updateAiAssistantTemplate,
    removeAiAssistantTemplate,
  };
};
